import I18n from 'I18n';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import styled from 'styled-components';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropdownWrapper = styled.div.withConfig({
  displayName: "EPDeviceSelectDropdown__DropdownWrapper"
})(({
  theme
}) => {
  return {
    display: 'inline-flex',
    maxWidth: '125px',
    /* The dropdown's border radius isn't automatically adjusted in a button group */
    'button:first-of-type': {
      borderBottomLeftRadius: theme.borderRadius['0'],
      borderTopLeftRadius: theme.borderRadius['0'],
      marginInlineStart: `-${theme.space['25']}`
    }
  };
});
const EPDeviceSelectDropdown = ({
  buttonSize,
  devices,
  dropdownStyles = {},
  onChange,
  selectedDevice
}) => {
  let isDeviceSelected = false;
  let buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "epDeviceSelectButton.custom"
  });
  if (devices.length === 0) return null;
  const devicesList = /*#__PURE__*/_jsx(List, {
    wrapChildren: true,
    children: devices.reduce((acc, device) => {
      let deviceLabel;
      let deviceName;
      let devicePreviewWidth;
      if (typeof device === 'object') {
        const {
          label,
          name,
          previewWidth
        } = device;
        const {
          units,
          value
        } = previewWidth || {};
        deviceLabel = label;
        deviceName = name;
        devicePreviewWidth = value && units ? `${I18n.formatNumber(value)}${units}` : null;
      } else {
        deviceLabel = device;
        deviceName = device;
      }
      if (selectedDevice === deviceName) {
        isDeviceSelected = true;
        buttonText = /*#__PURE__*/_jsx("span", {
          children: deviceLabel
        });
      }
      acc.push( /*#__PURE__*/_jsx(Button, {
        onClick: e => onChange(SyntheticEvent(deviceName, e)),
        children: /*#__PURE__*/_jsxs(TFlex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx("div", {
            children: deviceLabel
          }), devicePreviewWidth && /*#__PURE__*/_jsx(Small, {
            marginInlineStart: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "epDeviceSelectButton.editDeviceStyles",
              options: {
                devicePreviewWidth
              }
            })
          })]
        })
      }, deviceName));
      return acc;
    }, [])
  });
  return /*#__PURE__*/_jsx(DropdownWrapper, {
    children: /*#__PURE__*/_jsx(Dropdown, Object.assign({
      "data-test-id": "device-select-dropdown"
      // @ts-ignore Technically not supported but needed to match designs
      ,
      active: isDeviceSelected,
      buttonSize: buttonSize,
      buttonText: /*#__PURE__*/_jsx(TruncateString, {
        children: buttonText
      }),
      placement: "bottom left"
    }, dropdownStyles, {
      children: devicesList
    }))
  });
};
export default EPDeviceSelectDropdown;